
import SearchFavorite from "../../../assets/filled/SearchFavorite.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SearchFavoriteIcon({ className, dataTestid = "SearchFavoriteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SearchFavorite data-testid={dataTestid} className={classes} {...rest} />
  );
}
